// extracted by mini-css-extract-plugin
module.exports = {"paginationWrapper":"_b9cba1d","pagination":"_277ae93","inactiveDot":"_28966f2","clickable":"_88f3f0a"};